import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Input from "../../../ui/Input/Input";
import Button from "../../../ui/Button/Button";
import { validateEmail } from "../../../util/email";
import { createUser, completeCardId } from "../../../util/auth";
import { saveUserInfo } from "../../../db/users";
import { AuthContext } from "../../../context/AuthContext";
import Container from "../../../ui/Container/Container";
import "./CreateDoctor.css";

function CreateDoctor({ navigation }) {
  const [isAuthenticating, setIsAuthenticating] = useState(false);
  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();

  const [enteredFirstName, setEnteredFirstName] = useState("");
  const [enteredLastName, setEnteredLastName] = useState("");
  const [enteredSurName, setEnteredSurName] = useState("");
  const [enteredSpeciality, setEnteredSpeciality] = useState("");
  const [enteredCardId, setEnteredCardId] = useState("");
  const [enteredEmail, setEnteredEmail] = useState("");
  const [enteredOfficePhone, setEnteredOfficePhone] = useState("");
  const [enteredCellPhone, setEnteredCellPhone] = useState("");
  const [enteredIsTest, setEnteredIsTest] = useState(false);

  const [dataInvalid, setDataInvalid] = useState({
    firstName: false,
    lastName: false,
    surName: false,
    cardId: false,
    email: false,
    cellPhone: false,
  });

  function updateInputValueHandler(inputType, e) {
    const enteredValue = e.target.value;
    switch (inputType) {
      case "firstName":
        setEnteredFirstName(enteredValue);
        break;
      case "lastName":
        setEnteredLastName(enteredValue);
        break;
      case "surName":
        setEnteredSurName(enteredValue);
        break;
      case "speciality":
        setEnteredSpeciality(enteredValue);
        break;
      case "cardId":
        setEnteredCardId(enteredValue);
        break;
      case "email":
        setEnteredEmail(enteredValue);
        break;
      case "officePhone":
        setEnteredOfficePhone(enteredValue);
        break;
      case "cellPhone":
        setEnteredCellPhone(enteredValue);
        break;
    }
  }

  async function submitHandler() {
    const firstNameIsValid = enteredFirstName.trim().length > 0;
    const lastNameIsValid = enteredLastName.trim().length > 0;
    const surNameIsValid = enteredSurName.trim().length > 0;
    const cardIdIsValid = enteredCardId.trim().length > 4;
    const emailIsValid = validateEmail(enteredEmail.trim());
    const cellPhoneIsValid = enteredCellPhone.trim().length === 10;

    if (
      !firstNameIsValid ||
      !lastNameIsValid ||
      !surNameIsValid ||
      !emailIsValid ||
      !cardIdIsValid ||
      !cellPhoneIsValid
    ) {
      alert("Revisa los datos que ingresaste.");
      setDataInvalid({
        firstName: !enteredFirstName.length,
        lastName: !enteredLastName.length,
        surName: !enteredSurName.length,
        email: !validateEmail(enteredEmail),
        cardId: !(enteredCardId.length > 4),
        cellPhone: !(enteredCellPhone.length === 10),
      });
      return;
    }

    await signUpDoctor();
    navigate("/initAdmin");
  }

  async function signUpDoctor() {
    setIsAuthenticating(true);
    try {
      const newCard = completeCardId(enteredCardId);
      const loginInfo = await createUser(enteredEmail, newCard);
      const userInfo = {
        [loginInfo.userId]: {
          key: loginInfo.userId,
          name: enteredFirstName,
          lastName: enteredLastName,
          surName: enteredSurName,
          speciality: enteredSpeciality,
          cardId: enteredCardId,
          email: enteredEmail,
          officePhone: enteredOfficePhone,
          cellPhone: enteredCellPhone,
          isTest: enteredIsTest,
          doctorAgreed: false,
          doctorConfirmedData: false,
          role: "Doctor",
        },
      };
      await saveUserInfo(userInfo, authCtx.token);
      alert("Doctor registrado con éxito.");
    } catch (error) {
      alert("No se ha podido completar el registro, revisa tus datos.");
      setIsAuthenticating(false);
    }
  }

  if (isAuthenticating) {
    return <p>Creando doctor...</p>;
  }

  return (
    <Container title={"Crear nuevo doctor"} backNavigation={"/initAdmin"}>
      <div style={{ height: "96%", overflowY: "auto", margin: "10px" }}>
        <div className="cDoctorForm">
          <Input
            label="Nombre(s)"
            onUpdateValue={updateInputValueHandler.bind(this, "firstName")}
            value={enteredFirstName}
            isInvalid={dataInvalid.firstName}
            autoCorrect={false}
            autoCompleteType="off"
          />
          <Input
            label="Apellido"
            onUpdateValue={updateInputValueHandler.bind(this, "lastName")}
            value={enteredLastName}
            isInvalid={dataInvalid.lastName}
            autoCorrect={false}
            autoCompleteType="off"
          />
          <Input
            label="Segundo Apellido"
            onUpdateValue={updateInputValueHandler.bind(this, "surName")}
            value={enteredSurName}
            isInvalid={dataInvalid.surName}
            autoCorrect={false}
            autoCompleteType="off"
          />
          <Input
            label="Especialidad (opcional)"
            onUpdateValue={updateInputValueHandler.bind(this, "speciality")}
            value={enteredSpeciality}
            autoCorrect={false}
            autoCompleteType="off"
          />
          <Input
            label="Cedula Profesional (7 digitos)"
            onUpdateValue={updateInputValueHandler.bind(this, "cardId")}
            value={enteredCardId}
            keyboardType="number-pad"
            isInvalid={dataInvalid.cardId}
            autoCorrect={false}
            autoCompleteType="off"
          />
          <Input
            label="Correo Electrónico"
            onUpdateValue={updateInputValueHandler.bind(this, "email")}
            value={enteredEmail}
            keyboardType="email-address"
            isInvalid={dataInvalid.email}
            autoCorrect={false}
            autoCompleteType="off"
          />
          <Input
            label="Teléfono de oficina (opcional)"
            onUpdateValue={updateInputValueHandler.bind(this, "officePhone")}
            value={enteredOfficePhone}
            keyboardType="phone-pad"
            autoCorrect={false}
            autoCompleteType="off"
          />
          <Input
            label="Teléfono celular (10 dígitos)"
            onUpdateValue={updateInputValueHandler.bind(this, "cellPhone")}
            value={enteredCellPhone}
            keyboardType="phone-pad"
            isInvalid={dataInvalid.cellPhone}
            autoCorrect={false}
            autoCompleteType="off"
          />
          <div
            className="cDoctorTestCheck"
            onClick={() => setEnteredIsTest(!enteredIsTest)}
          >
            <span className="cDoctorLabel">Doctor de prueba</span>
            <div
              className={
                !enteredIsTest ? "cDoctorCheckBox" : "cDoctorCheckBoxError"
              }
            ></div>
          </div>
          <div className="cDoctorButtons">
            <Button onPress={submitHandler}>Crear doctor</Button>
          </div>
        </div>
      </div>
    </Container>
  );
}

export default CreateDoctor;
